import React, { Component } from 'react';
import _ from 'lodash';
import axios from 'axios';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PopupLink from '../../../shared-components/PopupLink/PopupLink';
import DynamicIframe from '../../../shared-components/DynamicIframe/DynamicIframe';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import { spinnerOpen, spinnerClose } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { FLOW_TYPE } from '../../../framework/App/AppConstants';
import { push } from 'connected-react-router';
import { PAGE_NAME } from '../../config/pageNames';
import { setServerData } from '../../../framework/store/ServerData/ServerDataActions';
import { reportFCI } from '../../../framework/store/ReportFCI/ReportFCIActions';
import Icon, { ICON_TYPE } from '../../../shared-components/Icon/Icon';

export const DEFAULT_IFRAME_LOAD_TIMEOUT = 25000;

export const addNonceToTags = (htmlString, nonce) => htmlString.replace(
    /<script>/gi,
    `<script nonce="${nonce}">`
);

const overrideTermsStyles = () => {
    const css = '.ppcTerms-header { display: none; }';
    const iframe = document.getElementById('program-agreement-iframe');

    if (_.get(iframe, 'contentWindow.document.head')) {
        const style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(css));
        iframe.contentWindow.document.head.appendChild(style);
    }
};

export class PaymentSecurityProgramAgreementContent extends Component {
    static propTypes = {
        isMobile: PropTypes.bool,
        onIframeLoaded: PropTypes.func.isRequired,
        onIframeError: PropTypes.func.isRequired,
        onBeforeIframeLoaded: PropTypes.func.isRequired,
        onTermsUnmount: PropTypes.func.isRequired,
        iframeLoadTimeout: PropTypes.number,
        htmlUri: PropTypes.string.isRequired,
        iframeContainerQuerySelector: PropTypes.string.isRequired,
        flowType: PropTypes.oneOf(Object.values(FLOW_TYPE)),
        nonce: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            htmlTerms: undefined,
        };
        props.onBeforeIframeLoaded();
    }

    componentDidMount = () => {
        const { htmlUri, onIframeError, flowType, nonce } = this.props;
        axios
            .get(htmlUri)
            .then(response => {
                if (response.status !== 200) {
                    throw new Error(`paymentsecurity_programagreement, handleIframeLoad=response_not_200, responseStatus=${response.status}`);
                }
                capeLog && capeLog('PaymentSecurity-ProgramAgreement-handleIframeLoad');
                const htmlTerms = addNonceToTags(response.data, nonce);
                this.setState({
                    htmlTerms,
                });
            })
            .catch(error => {
                capeLog && capeLog(`PaymentSecurity-ProgramAgreement-Error, ${error.message}`);
                return onIframeError(flowType);
            });
    }

    handleIframeWrite = () => {
        const iframe = document.querySelector(this.props.iframeContainerQuerySelector);
        const iframeDoc = iframe.contentDocument || _.get(iframe, 'contentWindow.document');
        try {
            overrideTermsStyles();
        } catch (err) {
            capeLog && capeLog('error_hiding_print_header=${err.message}');
        }
        try {
            iframeDoc.body.classList.add('ppcTerms-mini');
        } catch (err) {
            capeLog && capeLog(`PaymentSecurity-ProgramAgreement-Error, cannot showMini, err=${err.message}`);
        }
        this.props.onIframeLoaded();
    }

    componentWillUnmount() {
        this.props.onTermsUnmount();
    }

    render() {
        const {
            isMobile,
            htmlUri,     
        } = this.props;
        const { htmlTerms } = this.state;
        let termsIframe;

        if (htmlTerms) {
            termsIframe = (
                <DynamicIframe
                    scrolling="no"
                    autoHeight={true}
                    htmlString={htmlTerms}
                    extraHeight={32}
                    id="program-agreement-iframe"
                    className="PaymentSecurity-ProgramAgreement-iframe"
                    onHtmlStringWrite={this.handleIframeWrite}
                />
            );
        }

        capeLog && capeLog('PaymentSecurity-ProgramAgreement-render');
        return (
            <>
                <p className="printContent">
                    <Icon type={(isMobile) ? ICON_TYPE.PDF : ICON_TYPE.PRINT} className="print-agreement-icon" />
                    <PopupLink url={htmlUri} name="printHtmlLink">
                        {(isMobile) ? 'Download' : 'Print Version'}
                    </PopupLink>
                </p>
                <div id="paymentSecurityAgreement">
                    {termsIframe}
                </div>
            </>
        );
    }
}

export const mapStateToProps = state => {
    const iframeLoadTimeout = _.get(state, 'serverData.featureFlags.iframeTermsLoadTimeout') ||
        DEFAULT_IFRAME_LOAD_TIMEOUT;

    return {
        iframeLoadTimeout,
        flowType: _.get(state, 'serverData.flow'),
        nonce: _.get(state, 'serverData.nonce')
    };
};

export const mapDispatchToProps = dispatch => ({
    onBeforeIframeLoaded() {
        dispatch(spinnerOpen('base.loading-terms'));
    },
    onIframeLoaded() {
        dispatch(spinnerClose());
    },
    onIframeError(flowType) {
        const errorModel = {
            errorType: 'ppCreditPaymentSecurityProgramAgreementError',
            message: 'Error loading PaymentSecurity Program Agreement iframe',
        };
        if (flowType === FLOW_TYPE.DIRECT_APP) {
            errorModel.errorType = `${errorModel.errorType}${_.toUpper(FLOW_TYPE.DIRECT_APP)}`;
        }

        capeLog && capeLog(errorModel.message);

        dispatch(setServerData({ errorModel }));
        dispatch(trackTransition('pp_credit_paymentsecurity_programagreement', 'iframe_error_pp_credit_paymentsecurity_programagreement'));
        dispatch(push(PAGE_NAME.ERROR_PAGE));
        dispatch(reportFCI());
        dispatch(spinnerClose());
    },
    onTermsUnmount() {
        dispatch(spinnerClose());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSecurityProgramAgreementContent);
